<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="12">
        <v-card>
          <v-card-title
            class="mx-3 px-0 mb-3"
            style="border-bottom: 2px solid #d7531f"
          >
            <v-col cols="12" md="6">
              <v-icon style="margin-right: 20px; color: #00294b" size="50">
                mdi-account-group
              </v-icon>
              Operadores
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="d-flex align-center justify-end pa-0"
            >
              <v-btn @click="limpaOperador()" class="StyleButton mt-0"
                >Adicionar novo operador</v-btn
              >
            </v-col>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="operators"
              item-key="id"
              :footer-props="{
                showFirstLastPage: true,

                itemsPerPageText: 'Por Página',
                pageText: 'Página',
              }"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      text
                      v-bind="attrs"
                      v-on="on"
                      @click="abrirOperador(item)"
                      color="#ff770f"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar Operador</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      v-bind="attrs"
                      v-on="on"
                      text
                      color="#ff770f"
                      @click="deleteOperator(item.id)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Excluir Operador</span>
                </v-tooltip>
              </template>
              <template slot="progress">
                <v-progress-linear
                  indeterminate
                  color="#ff770fe0"
                ></v-progress-linear>
              </template>
              <template slot="loading"> Carregando operadores </template>
              <template slot="no-data"> Nenhum operador encontrado. </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      v-model="cadastroOperadores"
    >
      <v-card>
        <v-btn
          icon
          color="white"
          style="position: absolute; right: 15px; top: 15px"
          @click="cadastroOperadores = false"
        >
          <v-icon color="black">mdi-close</v-icon>
        </v-btn>
        <v-container>
          <v-row>
            <v-col cols="12" class="mt-5 d-flex justify-center flex-column">
              <h1
                class="titleScope"
                style="
                  color: #ff770f;
                  font-size: 58px;
                  text-transform: uppercase;
                "
              >
                CADASTRE UM NOVO OPERADOR!
              </h1>
              <p class="textScope">Preencha as informações do novo operador!</p>
            </v-col>
            <v-col cols="12">
              <v-form ref="form" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-row>
                      <v-col
                        style="padding: 0 12px !important"
                        cols="12"
                        md="12"
                      >
                        <v-text-field
                          label="Nome"
                          placeholder=""
                          v-model="operator.name"
                          outlined
                          color="#00294b"
                        ></v-text-field>
                      </v-col>

                      <v-col
                        style="padding: 0 12px !important"
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          label="Email"
                          placeholder=""
                          v-model="operator.email"
                          outlined
                          color="#00294b"
                        ></v-text-field>
                      </v-col>

                      <v-col
                        style="padding: 0 12px !important"
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          label="Login"
                          v-model="operator.login"
                          placeholder=""
                          color="#00294b"
                          outlined
                        >
                        </v-text-field>
                      </v-col>

                      <v-col
                        style="padding: 0 12px !important"
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          label="Senha"
                          placeholder=""
                          v-model="operator.passwd"
                          outlined
                          color="#00294b"
                        ></v-text-field>
                      </v-col>

                      <v-col
                        style="padding: 0 12px !important"
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          label="Confirmação de Senha"
                          placeholder=""
                          outlined
                          color="#00294b"
                        >
                        </v-text-field>
                      </v-col>

                      <v-btn :disabled="loadingCreate" @click="operator.id ? editOperator() : createOperator()" style="margin-top: 20px" class="StyleButton" block>
                        {{operator.id ? "Editar" : "Cadastrar"}} Operador
                      </v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "painelOperadores",
  data() {
    return {
      loadingCreate: false,
      valid: false,
      cadastroOperadores: false,
      headers: [
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "id",
        },
        { text: "Nome", value: "name" },
        { text: "Email", value: "email" },
        { text: "Ações", value: "actions" },
      ],
      operators: [],
      operator: {
        name: "",
        email: "",
        login: "",
        passwd: "",
        permissions: [
          {
            value: "",
          },
        ],
      },
    };
  },
  mounted() {
    this.listOperadores();
  },
  methods: {
    requireImg(img) {
      return require(`../assets/${img}`);
    },
    limpaOperador() {
      this.operator =  {
        id: undefined,
        name: "",
        email: "",
        login: "",
        passwd: "",
        permissions: [
          {
            value: "",
          },
        ],
      },
      this.cadastroOperadores = true
    },
    abrirOperador(operador) { 
      this.operator = operador
      this.cadastroOperadores = true
    },
    listOperadores() {
      this.loading = true;
      this.$http.get("operators").then((res) => {
        this.operators = res.data.result.operators;
        this.loading = false;
      });
    },
    editOperator() { 
      this.loadingCreate = true
      this.$http.post(`operators/edit/${this.operator.id}`,this.operator).then(res => { 
        if (res.data.status === "OK") { 
          this.$root.$emit("show-snack", {
            type: `success`,
            text: `Operador editado com sucesso!`,
          });     
        }
        this.loadingCreate = false
      }).catch(() => {
          this.$root.$emit("show-snack", {
            type: `error`,
            text: `Erro ao alterar o operador!`,
          });  
          this.loadingCreate = false;
        });
    },
    createOperator() {
      this.loadingCreate = true;
      this.$http
        .post("operators/add", this.operator)
        .then((res) => {
          if (res.data.status === 'OK') { 
            this.loadingCreate = false;
            this.listOperadores()
            this.cadastroOperadores = false;
            this.$root.$emit("show-snack", {
              type: `success`,
              text: `Operador criado com sucesso!`,
            });   
          }
        })
        .catch(() => {
          this.loadingCreate = false;
        });
    },
    deleteOperator(idOperator) {
      if (confirm(`Tem certeza que deseja remover o operador?`)) { 
        this.loadingDelete = true;
        this.$http.delete(`operators/remove/${idOperator}`).then((res) => {
          console.log(res);
          this.$root.$emit("show-snack", {
            type: `success`,
            text: `Operador removido com sucesso!`,
          });  
          this.listOperadores()
          this.loadingDelete = false;
        }).catch(() => { 
          this.loadingDelete = false
          this.$root.$emit("show-snack", {
            type: `error`,
            text: `Erro ao conectar ao servidor!`,
          });  
        });
      }
    },
    
  },
};
</script>
